import { useUserGroups } from '../hooks/useUserGroups';
import ComingSoon from './ComingSoon';

interface Props {
  group: string;
  moduleName: string;
  children: React.ReactNode;
}

export default function RequireGroup({ group, moduleName, children }: Props) {
  const { groups, loading } = useUserGroups();

  if (loading) {
    return null;
  }

  if (!groups.includes(group)) {
    return <ComingSoon module={moduleName} />;
  }

  return <>{children}</>;
}
